import React, { useState } from "react";

export default function UploadSection({ field, value, setValue, openViewer }) {
  const [uploading, setUploading] = useState(false);

  const files = value?.files || [];

  const handleFileUpload = async (e) => {
    const uploadedFiles = Array.from(e.target.files || []);
    if (uploadedFiles.length === 0) return;

    setUploading(true);
    try {
      // TODO: Implement actual file upload to Firebase storage
      // For now, create local file objects
      const newFiles = uploadedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        size: file.size,
        url: URL.createObjectURL(file),
      }));

      setValue({
        ...value,
        files: [...files, ...newFiles],
      });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="mt-4 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-300 dark:border-gray-600">
      <label className="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-2">
        📎 Upload Evidence
      </label>

      <input
        type="file"
        multiple
        disabled={uploading}
        onChange={handleFileUpload}
        className="block w-full text-xs text-gray-600 dark:text-gray-300 file:mr-2 file:py-2 file:px-3 file:rounded-md file:border-0 file:bg-orange-500 file:text-white hover:file:bg-orange-600 disabled:opacity-50"
      />

      {files.length > 0 && (
        <div className="mt-3 flex gap-2 flex-wrap">
          {files.map((file, idx) => (
            <div
              key={idx}
              className="flex items-center gap-2 bg-white dark:bg-gray-600 p-2 rounded-md border border-gray-300 dark:border-gray-500"
            >
              <a
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-orange-600 hover:text-orange-700 truncate max-w-[150px]"
                onClick={(e) => {
                  if (file.type.startsWith("image/")) {
                    e.preventDefault();
                    openViewer?.(file.url);
                  }
                }}
              >
                {file.name}
              </a>
              <button
                type="button"
                onClick={() =>
                  setValue({
                    ...value,
                    files: files.filter((_, i) => i !== idx),
                  })
                }
                className="text-xs text-red-600 hover:text-red-700"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
